export default {
  dataCenter: {
    exportReport: '导出报表',
    agent: '代理商',
    regionAgent: '区域代理',
    pleaseSelectAgent: '请选择代理商',
    performanceMonth: '业绩月份',
    pleaseSelectMonth: '请选择月份',
    regionAgentSelectTip: '区域代理可以选择本区域内所有代理商',
    agentVersionQueryTip: '查询区域内所有代理商的历史累计进货量、激活量及最新库存量',
    agentVersionNewQueryTip: '查询区域内所有代理商某个时间段的进货量、激活量及最新库存量',
    agentInfo: '代理商信息',
    agentId: '代理商ID',
    agentName: '代理商名称',
    agentLevel: '代理商级别',
    name: '姓名',
    phone: '电话',
    address: '地址',
    productType: '商品类型',
    pleaseSelectProductType: '请选择商品类型',
    stockQty: '库存量（台）',
    dispatchDate: '发货日期',
    pleaseSelectDispatchDate: '请选择发货日期',
    orderTime: '下单时间',
    sendTime: '发货时间',
    pleaseSelectSendTime: '请选择发货时间',
    provinceCityDistrict: '省市区',
    useTime: '使用时间',
    agentOrderingTip: '注：订货量统计，已确认的区域调货订单数量 + 总部已完款订单数量',
    statisticalCycle: '统计周期',
    agentRegion: '代理商所属区域',
    orderQty: '订货量',
    provinceCity: '所属省市',
    pleaseSelectOrderTime: '请选择下单时间',
    purchaseNo: '采购单编号',
    pleaseEnterPurchaseNo: '请输入采购单编号',
    pleaseSelectMonth: '请选择月份',
    query: '查询',
    pleaseSelectRegionAgent: '请选择区域代理',
    orderNo: '订单编号',
    pleaseEnterOrderNo: '请输入订单编号',
    activateTime: '激活时间',
    pleaseSelectActivateTime: '请选择激活时间',
    hardwareActiveCnt: '硬件激活量',
    softwareActiveCnt: '软件激活量',
    warehouseName: '所在仓库',
    hardwareActivateStatus: '硬件激活状态',
    voucherPrice: '裂变单价',
    cashPrice: '现金单价',
    totalPrice: '单价合计',
    softwareActivateTime: '软件激活时间',
    softwareActivateMonth: '软件激活月份',
    firstDispatchTime: '首次发货时间',
    latestPurchaseNo: '最新采购单号',
    defaultQueryCurrentMonth: '默认查询当前月份',
    to: '至',
    time: '时间',
    pleaseSelectTime: '请选择时间',
    dealerId: '经销商ID',
    dealerName: '经销商名称',
    yearMonth: '年月',
    crossRegionType: '跨区域类型',
    credit: '额度',
    reportCnt: '报备数量',
    reportActiveCnt: '报备激活数量',
    creditBalance: '剩余额度',
    reviewCnt: '复核数量',
    reviewBadCnt: '复核不合规数量',
    lastEmployeeCannotDelete: '最后一名员工不能删除',
    deleteFailRetry: '删除失败，请重试',
    pleaseSelectTargetPeriod: '请选择目标周期',
    targetCreateSuccess: '目标创建成功！',
    periodNoTargetQuery: '当前所选周期未设定目标，部分数据为0，您可选择非跨月周期查询',
    periodNoTargetSet: '当前所选周期未设定目标，部分数据为0，您可先设定当月目标',
    querySuccess: '查询成功',
    avgPriceRequired: '平均售价不能为空',
    conversionRateRequired: '转化率不能为空',
    visitRateRequired: '到访率不能为空',
    promiseVisitRateRequired: '诺访率不能为空',
    addWechatRateRequired: '加微率不能为空',
    supervisorSignRateRequired: '督学新签率不能为空',
    supervisorAvgPriceRequired: '督学均价不能为空',
    saveSuccessExclaim: '保存成功!',
    tipTimeSetSuccess: '提示时间设置成功',
    warehouse: '仓库',
    pleaseSelectWarehouse: '请选择仓库',
    productName: '商品名称',
    totalInventory: '总库存量',
    availableInventory: '可用库存量',
    partnerCloudWarehouse: '合作云仓',
    qu: '区域',
    liang: '进货量（台）',
    activate: '激活量（台）',
    inventory: '库存量（台）',
  }
}
